import { render, staticRenderFns } from "./CIDFlex.vue?vue&type=template&id=d22a0a66&scoped=true&"
import script from "./CIDFlex.vue?vue&type=script&lang=js&"
export * from "./CIDFlex.vue?vue&type=script&lang=js&"
import style0 from "./CIDFlex.vue?vue&type=style&index=0&id=d22a0a66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22a0a66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VContainer,VIcon})
